import { useMutation } from "@tanstack/react-query";
import { transactionApi } from "../../api";

/** Save once on the player's platform Customer; caller keys survive retries. */
export function useWalletSetupIntent() {
  return useMutation({
    mutationFn: (idempotencyKey: string) =>
      transactionApi.createWalletSetupIntent(idempotencyKey),
  });
}
